import { AwardCriterionType, type AwardCriterionDto, type AwardLetterCriterionDto } from "../../../../autogen/bff-api";

export interface LabelledCriterion {
  id: string;
  name: string;
}

interface NamedCriterion {
  id?: string | null;
  name?: string | null;
  parentName?: string | null;
  isPrice?: boolean;
}

export interface FallbackNames {
  criterion: string;
  price: string;
}

export const awardNotificationCriteria = (
  evaluated: AwardLetterCriterionDto[],
  announced: AwardCriterionDto[],
  fallbackNames: FallbackNames,
  justified: AwardLetterCriterionDto[] = [],
): LabelledCriterion[] => {
  if (evaluated.length > 0) return evaluated.map((criterion) => labelOf(criterion, fallbackNames));
  if (justified.length > 0) return justified.map((criterion) => labelOf(criterion, fallbackNames));
  return identified(flattenAnnounced(announced)).map((criterion) => labelOf(criterion, fallbackNames));
};

const flattenAnnounced = (announced: AwardCriterionDto[]): NamedCriterion[] =>
  announced.flatMap((criterion) => [
    { id: criterion.id, name: criterion.name, parentName: null, isPrice: criterion.type === AwardCriterionType.Price },
    ...(criterion.subCriteria ?? []).map((sub) => ({
      id: sub.id,
      name: sub.name,
      parentName: criterion.name,
    })),
  ]);

const identified = (criteria: NamedCriterion[]): (NamedCriterion & { id: string })[] =>
  criteria.filter((criterion): criterion is NamedCriterion & { id: string } => !!criterion.id);

const labelOf = (
  { id, name, parentName, isPrice }: NamedCriterion & { id: string },
  fallbackNames: FallbackNames,
): LabelledCriterion => {
  const own = name?.trim() || (isPrice ? fallbackNames.price : fallbackNames.criterion);
  return { id, name: parentName ? `${parentName} — ${own}` : own };
};
